import { render, staticRenderFns } from "./ProfileHistoryTransaction.vue?vue&type=template&id=262d2a33"
import script from "./ProfileHistoryTransaction.vue?vue&type=script&lang=js"
export * from "./ProfileHistoryTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports